import React, { useMemo } from "react"
import { cleanHTML, decodeHTML, isHtmlContent } from "../../helpers/decodeHTML"
import TruncatedTextRenderer from "../../ui/TruncatedTextRenderer"


 const BountyDescriptionInCard = ({  html,
  descriptionLinkPayload,
  htmlClassName = "prose  text-textPrimary max-w-none [&_p:empty]:before:content-['\\00a0'] [&_p:empty]:inline-block",
  paragraphClassName = "text-textPrimary",
  forceThreeLines = false }) => {
  const isHTML = isHtmlContent(decodeHTML(html))
  const htmlString = isHTML ? decodeHTML(html) : html

  // Clean HTML content for display
  const cleanedHTML = useMemo(() => {
    if (isHTML && htmlString) {
      return cleanHTML(htmlString)
    }
    return htmlString || ""
  }, [htmlString, isHTML])

  // Apply three-line styling when forceThreeLines is true
  const getClassName = () => {
    if (forceThreeLines) {
      return `line-clamp-3 overflow-hidden leading-5 break-words text-sm text-textPrimary max-w-none min-h-[3.75rem]`
    }
    return htmlClassName
  }

  const getParagraphClassName = () => {
    if (forceThreeLines) {
      return `line-clamp-3 overflow-hidden leading-5 break-words text-sm text-textPrimary min-h-[3.75rem]`
    }
    return paragraphClassName
  }

  return isHTML ? (
    <div
      className={`desc-html prose prose-a:text-blue-600 prose-a:underline ${getClassName()}`}
      dangerouslySetInnerHTML={{ __html: cleanedHTML }}
    />
  ) : (
    <TruncatedTextRenderer 
      text={cleanedHTML} 
      links={descriptionLinkPayload}
      paragraphClass={getParagraphClassName()}
      forceThreeLines={forceThreeLines}
    />
  )
}



export default BountyDescriptionInCard
